import { useMemo } from 'react'
import { CapacityMember, OptionItemsCoverage } from 'capacity/api/capacityGateway'
import { useGetCapacityMembersQuery } from 'capacity/reduxQuery'

export type CapacityProductsStatus = 'loading' | 'ready' | 'error'

export interface CapacityProducts {
    status: CapacityProductsStatus
    members: CapacityMember[]
    optionItems: OptionItemsCoverage
    updatedAt: number | undefined
    refetch: () => void
}

const NO_MEMBERS: CapacityMember[] = []

export function useCapacityProducts(accountSlug: string, capacityId: string | null): CapacityProducts {
    const { data, isLoading, isError, refetch, fulfilledTimeStamp } = useGetCapacityMembersQuery(
        { accountSlug, capacityId: capacityId ?? '' },
        { skip: !capacityId },
    )
    return useMemo(() => {
        const updatedAt = fulfilledTimeStamp
        if (!capacityId) {
            return { status: 'ready' as const, members: NO_MEMBERS, optionItems: 'full' as const, updatedAt, refetch }
        }
        if (isError) {
            return { status: 'error' as const, members: NO_MEMBERS, optionItems: 'failed' as const, updatedAt, refetch }
        }
        if (isLoading || !data) {
            return { status: 'loading' as const, members: NO_MEMBERS, optionItems: 'full' as const, updatedAt, refetch }
        }
        return { status: 'ready' as const, members: data.members, optionItems: data.optionItems, updatedAt, refetch }
    }, [capacityId, data, isLoading, isError, refetch, fulfilledTimeStamp])
}
